import React, {Component} from "react";
// import { useNavigate } from 'react-router-dom';
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Form,
  Container,
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Button,
  FormGroup
} from "reactstrap";

// core components
import nowLogo from "JCWLogo-white.svg";
import bgImage from "Main_Image.jpg";
import { loginHandler, sendSMS } from "loginHandler/login";
import { SHA256 } from "crypto-js";
import loading_image from "loading_animation.gif";
import {version} from "version.js";

class LoginPage extends Component {
	constructor(props) {
		super(props);
		
		this.state = {
			firstnameFocus: false,
			lastnameFocus: false,
			passwordSuccess: false,
			otp: 0,
			otpEntry: false,
			otpConfirm: 0,
			resendCode: false,
			countdown: 0
		};
	}

	async componentDidMount() {
		document.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                // this.login()
                if(this.state.passwordSuccess === true && this.state.otpEntry === false){
                    this.login()
                }
                else if(this.state.otpEntry === true){
                    this.confirmOTP()
                }
            }
        });

			//set local storage version to the current version
			localStorage.setItem("version", version);

			if('caches' in window){
				caches.keys().then((names) => {
					// Delete all the cache files
					names.forEach(name => {
						caches.delete(name);
					});
				});
			}

			
		
	}

	confirmOTP() {
		let otpConfirm = this.state.otpConfirm;
		let encryption = SHA256(otpConfirm).toString();

		console.log(encryption);

		if(this.state.otp === encryption){
			console.log('OTP confirmed');

			let current_datetime = new Date()
			let formatted_date = current_datetime.getFullYear() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getDate() + " " + current_datetime.getHours() + ":" + current_datetime.getMinutes() + ":" + current_datetime.getSeconds()

			sessionStorage.setItem("loggedIn", true)
    		sessionStorage.setItem("sessionStartTime", formatted_date)

			window.location.href = '/admin/dashboard';
		}
		else {
			alert('Incorrect OTP, please try again.');
		}
	}

	resendOTP() {
		this.generateOTP()
		this.setState({resendCode: true});
		// wait 20 seconds before allowing another resend
		this.generateOTP();
		this.setState({resendCode: true, countdown: 20}); // Start countdown at 20 seconds

		let intervalId = setInterval(() => {
			if (this.state.countdown > 0) {
			this.setState(prevState => ({countdown: prevState.countdown - 1}));
			} else {
			clearInterval(intervalId);
			this.setState({resendCode: false}); // Re-enable the resend OTP functionality
			}
		}, 1000);
	}

	generateOTP() {
		let email = document.getElementById('email').value;
		let otp = Math.floor(100000 + Math.random() * 900000).toString();
		let encryption = SHA256(otp).toString();
		this.setState({otp: encryption});
		console.log(otp);

		//send the otp to the user
		sendSMS(email, otp).then((resp) => {
			if(resp){
				console.log('OTP sent successfully')
				this.setState({otpEntry: true});
			}
			else {
				console.log('OTP not sent')
				alert('OTP not sent, please try again.');
				this.setState({otpEntry: false});
			}
		});
	}

	setfirstnameFocus() {
		this.setState({firstnameFocus: true});
	}

	setlastnameFocus() {
		this.setState({lastnameFocus: true});
	}

	async login() {
		//get the username and password
		let email = document.getElementById('email').value;
		let password = document.querySelector('input[type="password"]').value;
	
		loginHandler(email, password).then((resp) => {
			if(resp){
				this.setState({passwordSuccess: true});
				this.generateOTP();
			}
			else {
				document.getElementById('prompt').innerHTML = '<p style="color: red; padding: 0; font-size: 12px">Invalid username or password</p>'
			}
		});
	}

  render() {
    return (
    <>
      <div className="content">
        <div className="login-page">
          <Container>
            <Col xs={12} md={8} lg={6} className="ml-auto mr-auto">
              <Form>
                <Card className="card-login card-plain">
                  <CardHeader>
                    <div className="logo-container">
                      <img src={nowLogo} alt="now-logo" />
                    </div>
                  </CardHeader>
					<CardBody>
						<div className="otpBox"
							style={this.state.passwordSuccess === true && this.state.otpEntry === false ? {display: ''} : {display: 'none'}}
						>
							<img src={loading_image} alt="loading" style={{width: '60%'}} />
						</div>
						<div className="otpBox" id="otpentry" style={this.state.otpEntry ? {display: ''} : {display: 'none'}}>
							<FormGroup>
								<label>
									Enter the one-time passcode sent to your phone number:
								</label><br/>
								<Input
									className="form-control-lg"
									style={{width: '100%', color: 'black', border: '1px solid #E3E3E3', borderRadius: '5px', padding: '10px'}}
									name="confirmPassword"
									placeholder="Passcode"
									type="number"
									onChange={(e) => this.setState({otpConfirm: e.target.value})}
								/>
							</FormGroup>
							<FormGroup>
								<label hidden={this.state.resendCode === false ? true : false}>{this.state.countdown}</label>
								<button 
									class="button-as-link"
									onClick={() => this.resendOTP()}
									type="button"
									hidden={this.state.resendCode}
								>
									Resend code</button>
							</FormGroup>	
							<FormGroup>
								<Button
									onClick={() => this.confirmOTP()}
									className="mb-3 btn-round"
									style={{backgroundColor: '#3474BB'}}
									>
									Submit
								</Button>
							</FormGroup>
						</div>
						<div id="loginbox" style={this.state.passwordSuccess === false ? {display: ''} : {display: 'none'}}>
						<InputGroup
							className={
							"no-border form-control-lg " +
							(this.state.firstnameFocus ? "input-group-focus" : "")
							}
						>
							<InputGroupAddon addonType="prepend">
							<InputGroupText>
								<i className="now-ui-icons users_circle-08" />
							</InputGroupText>
							</InputGroupAddon>
							<Input
							type="text"
							id="email"
							placeholder="Email Address..."
							onFocus={(e) => this.setfirstnameFocus(true)}
							onBlur={(e) => this.setfirstnameFocus(false)}
							/>
						</InputGroup>
						<InputGroup
							className={
							"no-border form-control-lg " +
							(this.state.lastnameFocus ? "input-group-focus" : "")
							}
						>
							<InputGroupAddon addonType="prepend">
							<InputGroupText>
								<i className="now-ui-icons text_caps-small" />
							</InputGroupText>
							</InputGroupAddon>
							<Input
							type="password"
							placeholder="Password..."
							onFocus={(e) => this.setlastnameFocus(true)}
							onBlur={(e) => this.setlastnameFocus(false)}
							/>
						</InputGroup>
						<div id="prompt">
							
						</div>
						</div>
					</CardBody>
					<CardFooter>
						<Button
						block
						// color="primary"
						hidden={this.state.passwordSuccess}
						size="lg"
						// href="/admin/dashboard"
						onClick={() => this.login()}
						className="mb-3 btn-round"
						style={{backgroundColor: '#3474BB'}}
						>
						Login
						</Button>
					
					</CardFooter>
					</Card>
				</Form>
				</Col>
			</Container>
			</div>
      </div>
      <div
        className="full-page-background"
        style={{ backgroundImage: "url(" + bgImage + ")" }}
      />
    </>
	);
	}
}

export default LoginPage;